import { createStyles, rem } from '@mantine/core'

export default createStyles(
  (theme, { expandWidget }: { expandWidget: boolean }) => {
    return {
      root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between',
        gap: rem(0),
      },
      header: {
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit',
        flexShrink: 0,
      },
      footer: {},
      bodyWrapper: {},
      action: {
        padding: `${rem(12)} ${rem(16)}`,
        ...(!expandWidget && {
          paddingTop: 0,
        }),
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: rem(12),
        [theme.fn.largerThan('sm')]: {
          padding: rem(16),
        },
      },
      scrollArea: {
        height: '100%',
        overflowY: 'auto',
        ...(!expandWidget && {
          maxHeight: rem(250),
        }),
      },
      scrollBody: {
        padding: rem(16),
        paddingBottom: 0,
        '*': {
          overflowAnchor: 'none',
        },
        '#anchor': {
          overflowAnchor: 'auto',
          height: '1px',
        },
        [theme.fn.largerThan('sm')]: {
          /* width */
          '::-webkit-scrollbar': {
            width: rem(6),
          },
          /* Track */
          '::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          /* Handle */
          '::-webkit-scrollbar-thumb': {
            background: theme.colors.neutral[3],
            borderRadius: rem(6),
          },
        },
      },
    }
  },
)
